const c = {
  id: "OregonPick4",
  name: "Pick 4",
  style: {
    colorPrimary: "#00438c"
  }
};
export {
  c as default
};
